import {useEffect} from "react";
import {useLocation, useMatch} from "react-router";
import {useNavigate} from "react-router-dom";

export function Redirect({
  from,
  to,
  else: fallback,
  paramsNames,
  keepCurrentLocation,
}: {
  from?: string;
  to: string;
  else?: string;
  paramsNames?: Array<string>;
  keepCurrentLocation?: boolean;
}) {
  let navigate = useNavigate();
  let location = useLocation();
  let matches = useMatch(from || "/");

  if (from && paramsNames) {
    if (matches !== null) {
      for (const paramName of paramsNames) {
        to = to.replaceAll(":" + paramName, matches.params[paramName] as string);
      }
    } else {
      to = fallback as string;
    }
  }

  const target =
    keepCurrentLocation && !to.includes("redirect=")
      ? `${to}?redirect=${encodeURIComponent(location.pathname + location.search)}`
      : to;

  useEffect(() => {
    navigate(target, {replace: true});
  });

  return null;
}
